import {useRouter} from '#imports';

export function useRouteHelper() {
    const router = useRouter();

    function isLocaleRoute(url: string): boolean {
        return router.getRoutes().some((r) => _stripMaybeLocaleParam(r.path) === url);
    }

    // Locale-prefixed apps rewrite routes to `/:maybeLocale(...)/…`; compare the unprefixed path.
    function _stripMaybeLocaleParam(path: string): string {
        return path.replace(/^\/:maybeLocale(?:\([^)]*\))?\?/, '') || '/';
    }

    return {
        isLocaleRoute,
    };
}
